import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    source: 'mux',
    youtubeUrl: '',
    twitchChannel: '',
    embedUrl: '',
    showProductShelf: false,
    playbackId: '',
    status: 'idle',
    title: '',
    description: '',
    latencyMode: 'standard',
    autoRecord: true,
    lastLiveAt: null,
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'default',
    layout: '1',
  },
  containerDesign: {},

  // Creator-only data (fetched separately)
  streamKey: '',
  rtmpUrl: '',
  totalStreamMinutes: 0,
  maxDurationMinutes: 240,
};

export const livestreamSlice = createSlice({
  name: 'livestream',
  initialState,
  reducers: {
    livestreamStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;
      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { containerDesign } = blockDesign ?? {};

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        source: blockContent?.source ?? 'mux',
        youtubeUrl: blockContent?.youtubeUrl ?? '',
        twitchChannel: blockContent?.twitchChannel ?? '',
        embedUrl: blockContent?.embedUrl ?? '',
        showProductShelf: blockContent?.showProductShelf ?? false,
        playbackId: blockContent?.playbackId ?? '',
        status: blockContent?.status ?? 'idle',
        title: blockContent?.title ?? '',
        description: blockContent?.description ?? '',
        latencyMode: blockContent?.latencyMode ?? 'standard',
        autoRecord: blockContent?.autoRecord ?? true,
        lastLiveAt: blockContent?.lastLiveAt ?? null,
        heading: {
          title: blockContent?.heading?.title ?? '',
          description: blockContent?.heading?.description ?? '',
          textAlign: blockContent?.heading?.textAlign ?? 'left',
          image: blockContent?.heading?.image ?? '',
          divider: blockContent?.heading?.divider ?? '',
          position: blockContent?.heading?.position ?? '',
        },
      };

      state.blockDesign = {
        view: blockDesign?.view ?? 'default',
        layout: blockDesign?.layout ?? '1',
      };
    },
    livestreamClear: () => initialState,

    livestreamUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    livestreamUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    livestreamUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    livestreamUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
    livestreamUpdateStreamKey: (state, action) => {
      const { streamKey, rtmpUrl, totalStreamMinutes, maxDurationMinutes } = action.payload;
      state.streamKey = streamKey ?? '';
      state.rtmpUrl = rtmpUrl ?? '';
      state.totalStreamMinutes = totalStreamMinutes ?? 0;
      state.maxDurationMinutes = maxDurationMinutes ?? 240;
    },
    livestreamUpdateStatus: (state, action) => {
      state.blockContent.status = action.payload;
    },
  },
});

export const {
  livestreamStore,
  livestreamClear,
  livestreamUpdateIsLoading,
  livestreamUpdateIsActive,
  livestreamUpdateBlockContent,
  livestreamUpdateBlockDesign,
  livestreamUpdateStreamKey,
  livestreamUpdateStatus,
} = livestreamSlice.actions;

export const selectLiveStreamIsLoading = (state) => state.livestream.isLoading;
export const selectLiveStreamId = (state) => state.livestream.id;
export const selectLiveStreamUID = (state) => state.livestream.uid;
export const selectLiveStreamSID = (state) => state.livestream.sid;
export const selectLiveStreamBlockContent = (state) => state.livestream.blockContent;
export const selectLiveStreamBlockDesign = (state) => state.livestream.blockDesign;
export const selectLiveStreamContainerDesign = (state) => state.livestream.containerDesign;
export const selectLiveStreamStreamKey = (state) => state.livestream.streamKey;
export const selectLiveStreamRtmpUrl = (state) => state.livestream.rtmpUrl;
export const selectLiveStreamTotalMinutes = (state) => state.livestream.totalStreamMinutes;
export const selectLiveStreamMaxMinutes = (state) => state.livestream.maxDurationMinutes;

export default livestreamSlice.reducer;
